
import PartitionDetail from './PartitionDetail.vue'
import BasicInfo from './BasicInfo.vue'
import { Payload, octToHex } from '../services/payload'
import {
  downloadFile,
  ensureSuffix,
  trimOTAPackage,
  ZipFile
} from '@/services/trim_zip'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    PartitionDetail,
    BasicInfo
  },
  props: {
    zipFile: {
      type: ZipFile,
      default: null
    },
    payload: {
      type: Payload,
      default: null
    }
  },
  methods: {
    octToHex: octToHex,
    async exportOTAPackage() {
      const blob = await trimOTAPackage(this.payload as Payload)
      const downloadNode = this.$refs['download'] as HTMLAnchorElement
      downloadFile(
        blob,
        downloadNode,
        'trimmed_' + ensureSuffix(this.zipFile.getFileName(), '.zip')
      )
    }
  },
  computed: {
    dynamicPartitions(): string[] {
      return (
        this.payload.manifest?.dynamicPartitionMetadata?.groups?.flatMap(
          g => g.partitionNames || []
        ) || []
      )
    },
    payloadHash(): string {
      const hash = this.payload?.getPayloadHash();
      if (!hash) {
        return "";
      }
      return octToHex(hash, false);
    },
  }
})
